	// Définition des variables
	var mainElement, parentElement, currentElement,
		classMenu = "nav-menu",
		classHasChildren = "menu-item-has-children",
		classHover = "mhover";
	var lastScrollTop = 0;


	// Fonction du menu Accessible
	$.fn.menuAccessible = function () {
		var menu = $(this);

		// Gestion du focus au clavier : Tab & Shift+Tab
		$("."+classMenu+" [itemprop='url']").focus( function() {

			// Stocke l'element courant
			currentElement = $(this).parent();

			// Stocke le menu de 1er niveau
			mainElement = currentElement.parents('li').last();
			if ( typeof(mainElement.attr("id")) === 'undefined' ) {
				mainElement = currentElement;
			}

			// On supprime le classHover sur tous les enfants
			$("."+classMenu).find("li").removeClass(classHover);

			// N'ajoute la classHover que si l'element a des enfants
			if ( currentElement.hasClass(classHasChildren) ) {
				currentElement.addClass(classHover);
			}
			// Ajoute la classHover a tous les parents
			currentElement.parents("li").addClass(classHover);
		});

		$(".sub-menu-parent .menu-item-has-children")
			.mouseenter( function(e) {
				$(this).parent().addClass("active");
			})
			.mouseleave(function() {
				$(this).parent().removeClass("active");
			});

		// Gestion des fleches de direction pour sauter les sous-menus
		$(menu).keydown(function(e){
			switch (e.keyCode) {
				// Flèche droite
				case 39 :
					e.preventDefault();
					// Supprime la classHover a tous les parents
					currentElement.parents("li").removeClass(classHover);
					// Passe au menu de 1er niveau suivant
					mainElement.next().children("a").focus();
				break;

				// Flèche gauche
				case 37 :
					e.preventDefault();
					// Supprime la classHover a tous les parents
					currentElement.parents("li").removeClass(classHover);
					// Passe au menu de 1er niveau precedent
					mainElement.prev().children("a").focus();
				break;

				// Shift + Tab
				case 9 :
					if ( e.shiftKey ) {
						// Passe au menu precedent du meme niveau
						// sinon si first-child, on conserve la navigation clavier classique
						if ( !currentElement.is(":first-child") ) {
							e.preventDefault();
							currentElement.prev().children("a").focus();
						}
					}
				break;
			}
		});

		// Desactivation de tous les focus au survol de la souris
		$(menu).mouseenter(function() {
			$(":focus").blur();
			$("."+classMenu).find("li").removeClass(classHover);
		});
	};

	// Initialisation du menu accessible
	$("."+classMenu).menuAccessible();

	$(document).ready( function(){
		initMenu();
		reinitMenuState();
	});

	function initMenu() {
		desktopMenu();
		mobileMenu();
	}

	function desktopMenu() {
		desktopMenuMegamenu();
		desktopMenuToggle();
		desktopMenusticky();
		desktopMenuSearch();
		desktopMenuHideHomepage();
		$(window).on("scroll", function(e) {
			desktopMenusticky();
		});
	}

	function mobileMenu() {
		mobileMenuMegamenu();
		mobileMenuToggle();
		mobileMenusticky();
		$(window).on("scroll", function(e) {
			mobileMenusticky();
		});
	}

	function mobileMenuToggle() {
		$('.burgermobile.toggle-menu').click( function(e) {
			e.preventDefault();

			$('.mobilemenu').toggleClass("toggleBurgerMenu");
			$('.mobilemenu').next('#megamenu').toggleClass("menu-active");

			if($('.mobilemenu').next('#megamenu').hasClass("menu-active")) {
				$('html, body').css('overflow', 'hidden');
			}else {
				$('html, body').removeAttr('style');
			}

			if($('.mobilemenu').hasClass('stickynavmobile') && $(window).scrollTop() < 90){
				$('.mobilemenu').removeClass('stickynavmobile');
			}else if (!$('.mobilemenu').hasClass('stickynavmobile') && $(window).scrollTop() > 90){
				$('.mobilemenu').addClass('stickynavmobile');
			}
		});
	}

	function mobileMenuMegamenu() {
		$('.mobilemenu ~ #megamenu .nav-menu > .menu-item').click(function() {
			if($(window).width() < 1000) {
				if($(this).hasClass('menu-open')) {
					$(this).removeClass('menu-open');
					$(this).children('.megamenu').slideUp('200','linear');
				}else {
					$(this).addClass('menu-open');
					$(this).children('.megamenu').slideDown('200','linear');
				}
			}
		});
	}

	function mobileMenusticky() {
		if($(window).width() < 1000) {
			let st = $(window).scrollTop();

			if ( $(window).scrollTop() > 90 && !$('.homepagemenu').hasClass('menu-active')) {
				$('.mobilemenu').addClass('stickynavmobile');
			}
			else if ( $(window).scrollTop() <= 90) {
				$('.mobilemenu').removeClass('stickynavmobile');
			}

			lastScrollTop = st;
		}
	}

	function desktopMenuToggle() {
		$('#megamenu .burgerdesktop').click(function() {
			$('#megamenu').removeClass("menu-active");
			$('.megamenu').removeClass("menu-open");
			$('#megamenu .menu-item-has-children .text-item').removeClass("isOpen");
			$(this).removeClass("toggleBurgerMenu");
		});
	}

	function desktopMenuMegamenu() {
		$('#megamenu .menu-item-has-children').hover(function() {
			if($(window).width() >= 1000) {

				$('html, body').removeAttr('style');

				$('#megamenu .menu-item-has-children .text-item').removeClass('isOpen');
				$('.megamenu').removeClass('menu-open');

				$(this).children('.megamenu').addClass("menu-open");
				$(this).children('a').addClass('isOpen');
			}
		});

		$('#megamenu .menu-item-has-children').mouseleave(function() {
			if($(window).width() >= 1000) {
				$('html, body').removeAttr('style');
				$('#megamenu .menu-item-has-children .text-item').removeClass('isOpen');
				$(this).children('a').removeClass('isOpen');
				$('.megamenu').removeClass('menu-open');
			}
		});
	}

	// Sticky menu
	function desktopMenusticky() {
		let st = $(window).scrollTop();
		if($(window).width() >= 1000) {
			// Passe le menu en sticky
				if(st > lastScrollTop && $('#megamenu').hasClass("showmenu")) {
					$('#megamenu').removeClass("showmenu");

					//remove megamenu au scoll bas
					$('#megamenu').removeClass("menu-active");
					$('.megamenu').removeClass("menu-open");
					$('#megamenu .menu-item-has-children .text-item').removeClass("isOpen");
					$('.search-bar').removeClass("search-active");
					$('.search-input').slideUp(300);
				}else if (st < lastScrollTop && !$('#megamenu').hasClass("showmenu") && !$("#megamenu").hasClass("menu-active")){
					$('#megamenu').addClass("showmenu");
				}

				if($("#megamenu").hasClass("menu-active")){
					$('#megamenu').addClass("showmenu");
				}

			lastScrollTop = st;
		}
	}

	function desktopMenuSearch() {
		if($(window).width() >= 1000) {
			$('#megamenu .searchlogo').click(function (e) {
				e.preventDefault();
				if (!$('.search-bar').hasClass("search-active")) {
					$('.search-bar').addClass("search-active");
					$('.search-input').slideDown(300);
				}else {
					$('.search-bar').removeClass("search-active");
					$('.search-input').slideUp(300);
				}
			});
		}
	}

	function desktopMenuHideHomepage() {
		if($('.homepagemenu')[0] && $(window).scrollTop() > 100 && $(window).width() >= 1000){
			$('#megamenu').addClass('showmenu');
		}
	}

	function reinitMenuState() {
		$(window).resize(function() {
			if($(window).width() < 1000 && !isMobile) {
				if($('#megamenu').hasClass('menu-active')) {
					$('#megamenu').removeClass('menu-active');
					$('.mobilemenu').removeClass('toggleBurgerMenu');
				}
				$('.burgermobile').removeClass('toggle-menu');
				$('.stickynavmobile').removeClass('toggleBurgerMenu');
				isMobile = true;
			}else if($(window).width() >= 1000 && isMobile) {
				$('html, body').removeAttr('style');
				$('.search-active').removeClass('search-active');
				$('.search-input').slideUp(300);
				$('#megamenu').removeClass('menu-active')
				$('#megamenu').removeClass('showmenu')
				$('#megamenu .nav-menu > .menu-item').removeClass('menu-open');
				$('#megamenu .megamenu').removeClass('menu-open');
				isMobile = false;
			}
		})
	}